import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '@/app/store'
import { urlregister } from '@/lib/custom'

import { availableState } from '@/features/authSlice'
import { dialogRegisterQuestionnaireState } from '@/features/dialogSlice'

const useNoLogin = () => {
  const dispatch = useDispatch()
  const router = useRouter()

  const loginTypeStateSelector = useSelector((state: RootState) => state.auth.loginType)

  const NoAuthLoginFunc = async () => {
    try {
      /***
       * アカウント登録(バックエンドで登録)
       */
      const cognitoRegisterFunc = await fetch(`${urlregister}`, {
        method: 'POST',
        headers: {
          'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
          'X-Local': localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_i18nextLng`),
        },
      })

      const result = await cognitoRegisterFunc.json()

      if (result.status === 200) {
        localStorage.setItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`, `${result.id_token}`)

        localStorage.setItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-refresh`, `${result.refresh_token}`)

        localStorage.setItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-username`, `${result.username}`)

        dispatch(dialogRegisterQuestionnaireState(true))

        return
      }

      if (result.status === 400) {
        alert(result.message)
        dispatch(availableState(false))
        return
      }
    } catch (error) {
      dispatch(availableState(false))
    }
  }

  useEffect(() => {
    if (loginTypeStateSelector === 9) {
      try {
        if (!localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`)) {
          NoAuthLoginFunc().then(() => router.push('/'))
          return
        }
      } catch (error) {
        console.log(error)
      }
      return
    }
  }, [loginTypeStateSelector])
}

export default useNoLogin
